import axiosInstance from "./axiosInstance";

export const getSettingsData = () => {
  return axiosInstance.get(`settings`);
};
